import { BookOpen, Expand } from "lucide-react";
import { useEffect, useState } from "react";
import type {
  TeachingSectionName,
  TeachingUnitRecord,
} from "../data/buildGraphData";

export const teachingTabs: TeachingSectionName[] = [
  "理解",
  "方法",
  "实验",
  "证伪",
  "AI 协作",
];

type NodeDetailProps = {
  unit: TeachingUnitRecord;
  onOpenReader: (section: TeachingSectionName) => void;
};

export function NodeDetail({ unit, onOpenReader }: NodeDetailProps) {
  const [activeTab, setActiveTab] = useState<TeachingSectionName>("理解");

  useEffect(() => setActiveTab("理解"), [unit.number]);

  return (
    <section className="node-detail" aria-label="知识节点详情">
      <header className="detail-heading">
        <span className="detail-number">N{String(unit.number).padStart(3, "0")}</span>
        <h2>{unit.number} {unit.title}</h2>
        <div className="detail-meta">
          {unit.questionIds.map((questionId) => (
            <span key={questionId}>{questionId}</span>
          ))}
          {unit.tags.filter((tag) => !/条$/u.test(tag)).map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>
      </header>

      <div className="detail-tabs" role="tablist" aria-label="教学内容">
        {teachingTabs.map((tab) => (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={activeTab === tab}
            className={activeTab === tab ? "is-active" : ""}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="detail-copy" role="tabpanel" aria-label={activeTab}>
        {unit.sections[activeTab].map((paragraph, index) => (
          <p key={`${activeTab}-${index}`}>{paragraph}</p>
        ))}
      </div>

      <button
        className="reader-button"
        type="button"
        onClick={() => onOpenReader(activeTab)}
        aria-label="展开阅读"
      >
        <Expand size={16} aria-hidden="true" />
        展开阅读
      </button>
    </section>
  );
}

export function EmptyDetail() {
  return (
    <section className="empty-detail" aria-label="节点详情">
      <BookOpen size={24} aria-hidden="true" />
      <h2>选择一个知识节点</h2>
      <p>点击画布中的节点，查看理解、方法、实验、证伪与 AI 协作。</p>
    </section>
  );
}
